import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MobileSamplesTable from './MobileAlertsTabs/MobileSamplesTable';

import Paper from '@mui/material/Paper';
import TabsContainer from '../Custom/Tabs/TabsContainer';
import MobileDevicesBIST from './MobileDevicesBIST';
import MobileDeviceHistory from './MobileDeviceHistory';
import {
  decToHex,
  formatMobileDeviceID,
} from '../../containers/UIhelper/UIhelper';

const MobileDevicesTabs = (props, context) => {
  const {
    uiInfo,
    selectedFeature,
    selectedDeviceBist,
    selectedDeviceHistory,
    featureType,
    showDetails,
    timeZone,
    samples,
    samplesIndexMap,
    selectedDeviceId,
    options,
  } = props;
  const panelHeight = 0.435 * uiInfo.pageHeight;
  // Clip the panel so its content can never spill onto the map behind it.
  const panelStyle = { height: panelHeight, overflow: 'hidden' };
  // Size the scrollable tab body to fit inside the panel (minus the tab bar) so
  // a long history scrolls internally instead of overflowing the panel.
  const tabBodyStyle = { maxHeight: panelHeight - 60, overflowY: 'auto' };

  const panelClasses = classNames('alert-details', { show: showDetails });

  function closePanel() {
    props.toggleDetailsVisibility(false);
    props.clearSelectedFeature();
  }

  // Open the panel whenever a device is selected and close it once the selection
  // is cleared. Keying off `selectedDeviceId` (not the BIST data) means devices
  // with no BIST samples still open their details, and the panel can't reopen
  // itself with an "undefined" title after close.
  React.useEffect(() => {
    if (selectedDeviceId) {
      if (!showDetails) {
        props.toggleDetailsVisibility(true);
      }
    } else if (showDetails) {
      props.toggleDetailsVisibility(false);
    }
  }, [selectedDeviceId, showDetails]);

  const onPageIndexChange = (page) => {
    // console.log(page);
  };

  return (
    <Paper className={panelClasses} style={panelStyle}>
      <TabsContainer
        title={context.t('device_id_val', {
          id:
            selectedDeviceId &&
            formatMobileDeviceID(decToHex(selectedDeviceId)),
        })}
        handleClose={closePanel}
        tabs={[
          // Samples (BIST) tab hidden for now — re-enable when needed.
          // {
          //   label: context.t('samples'),
          //   component: (
          //     <MobileDevicesBIST
          //       timeZone={timeZone}
          //       uiInfo={uiInfo}
          //       bist={props.selectedDeviceBist}
          //       notify={props.notify}
          //     />
          //   ),
          // },
          {
            label: context.t('details'),
            style: tabBodyStyle,
            component: (
              <MobileDeviceHistory
                history={selectedDeviceHistory || []}
                actionOptions={options && options.MobileDevicesActionCode}
                stateOptions={options && options.MobileDevicesState}
                timeZone={timeZone}
                onAddComment={(comment) =>
                  props.addMobileDeviceComment(selectedDeviceId, comment)
                }
              />
            ),
          },
        ]}
      />
    </Paper>
  );
};

MobileDevicesTabs.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default MobileDevicesTabs;
